import { render, staticRenderFns } from "./PrivatePage.vue?vue&type=template&id=2c71e90f&"
import script from "./PrivatePage.vue?vue&type=script&lang=js&"
export * from "./PrivatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports